export const appsAppGroupIdChartsContentCards = "/apps/:app_group_id/charts/content_cards";
